/* eslint-disable react/prefer-stateless-function */
import React, { forwardRef } from 'react';
import I18nContext from './i18n-context';


const localize = Component => forwardRef((props, ref) => (
  <I18nContext.Consumer>
    { context => <Component {...props} ref={ref} {...context} /> }
  </I18nContext.Consumer>
));

export default localize;



// WEBPACK FOOTER //
// ./src/i18n/i18n-hoc.js